const ConfirmationModal = ({ title, message, description, onClose, onConfirm, isLoading = false }) => {
  const mode = title?.includes('Edit');
  return (
    <div className="cfg-modal-backdrop" onClick={onClose} style={{zIndex:'99999'}}>
      <div className="cfg-modal" onClick={e => e.stopPropagation()}>
        <div className="cfg-modal-header">
          <span className="cfg-modal-title">{title}</span>
          <button type="button" className="cfg-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="cfg-modal-body">
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <p style={{ color: '#d6eaf8', fontSize: '14px', marginBottom: '16px', lineHeight: '1.6' }}>
              {message}
            </p>
            {description && (
              <div style={{
                backgroundColor: 'rgba(76,195,230,0.1)',
                border: '1px solid rgba(76,195,230,0.3)',
                borderRadius: '4px',
                padding: '12px',
                marginBottom: '24px',
                color: '#4cc3e6',
                fontSize: '13px',
                fontWeight: '600'
              }}>
                "{description}"
              </div>
            )}
          </div>
        </div>

        <div className="cfg-modal-footer" style={{ 
          display: 'flex', 
          gap: '12px', 
          justifyContent: 'flex-end',
          padding: '16px 24px',
          borderTop: '1px solid rgba(40,80,140,0.3)'
        }}>
          <button
            type="button"
            className="cfg-btn cfg-btn--secondary"
            onClick={onClose}
            disabled={isLoading}
            style={{
              padding: '8px 24px',
              fontSize: '13px',
              backgroundColor: 'transparent',
              border: '1px solid rgba(76,195,230,0.3)',
              color: '#4cc3e6',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="cfg-btn cfg-btn--danger"
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              padding: '8px 24px',
              fontSize: '13px',
              backgroundColor: '#e05c5c',
              border: 'none',
              color: '#fff',
              borderRadius: '4px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.6 : 1
            }}
          >
            {(isLoading && !mode) ? 'Deleting...' : (isLoading && mode) ? 'Saving...' : !mode ? 'Delete' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
